import Base from './base'
import Color, { colorToRGBA } from '../color.js'
import _ from 'underscore'
import URI from 'urijs'
import { hasRootKey, popRootKey } from '../util'

export const CHART_TYPES = ['bar', 'colum', 'donut', 'standard', 'cluster', 'spotlight', 'wordcloud']

export const SCALE_MAP = [
  {
    newKey: 'keyword_scale',
    oldKey: 'chartKeywordScale',
    scale: [0.3, 2.5]
  },
  {
    newKey: 'label_scale',
    oldKey: 'chartLabelScale',
    scale: [0.3, 2.5]
  },
  {
    newKey: 'voting_instructions_scale',
    oldKey: 'headerInstructionScale',
    scale: [1, 1.45]
  },
  {
    newKey: 'title_scale',
    oldKey: 'headerScale',
    scale: [0.4, 3]
  },
  {
    newKey: 'message_scale',
    oldKey: 'messageScale',
    scale: [0.4, 3]
  }
]

function rmCamelCaseAttrs (attrs) {
  attrs = attrs || {}
  attrs = JSON.parse(JSON.stringify(attrs, (k, v) => v === undefined ? null : v))
  const BLACKLIST_ATTRS = [
    ...SCALE_MAP.map((scale) => scale.oldKey)
  ]
  _.intersection(BLACKLIST_ATTRS, Object.keys(attrs)).forEach((attr) => {
    delete attrs[attr]
  })
  return attrs
}

export default class FlashOptions extends Base {
  get defaults () {
    return {
      segmentationSizedByPercentage: true
    }
  }

  url () {
    return URI('/polls').segment(this.poll.permalink()).segment('flash_options.json').toString()
  }

  isNew () {
    return false
  }

  isSegmented () {
    if (this.poll) {
      const isComparisonReportingEnabled = this.poll.get('comparison_reporting')
      const isMultipleChoicePollType = this.poll.type() === 'multiple_choice_poll'
      if (isComparisonReportingEnabled && isMultipleChoicePollType) {
        return this.has('teamPollPermalink') && !!this.get('teamPollPermalink')
      } else {
        return false
      }
    } else {
      return this.has('teamPollPermalink') && !!this.get('teamPollPermalink')
    }
  }

  toJSON (options = {}) {
    _.defaults(options, { root: true })
    const json = rmCamelCaseAttrs(super.toJSON(...arguments))

    if (options.root) {
      return { flash_options: json }
    } else {
      return json
    }
  }

  setChartType (newType) {
    newType = newType.toLowerCase()

    if (CHART_TYPES.includes(newType)) {
      this.set('chart_type', newType)
    }
  }

  enableSegmentation (permalink) {
    if (!permalink) return

    if (this.poll) {
      if (this.poll.get('comparison_reporting')) {
        this.set({ teamPollPermalink: permalink })
      }
    } else {
      this.set({ teamPollPermalink: permalink })
    }
  }

  disableSegmentation () {
    if (!this.get('teamPollPermalink')) return
    this.set({ teamPollPermalink: null })
  }

  getColorRGBA (property, alpha = 1) {
    return colorToRGBA(this.get(property), alpha)
  }

  getColorHex (property) {
    return Color.intToHex(this.get(property))
  }

  getColorARGB (property, alpha = 1) {
    const hex = Color.intToHex(this.get(property))
    if (hex) {
      alpha = Math.floor(alpha * 255).toString(16)

      return `#${alpha}${hex.slice(1)}`
    } else {
      return undefined
    }
  }

  set (key, value, options) {
    if (!key) return this

    let attrs = {}

    if (typeof key === 'object') {
      attrs = key
      options = options || value
    } else {
      (attrs = {})[key] = value
    }

    // TODO: Remove this hack when backend stops requiring root keys for any
    // POST requests.
    if (attrs.flash_options) {
      if (hasRootKey(attrs)) {
        attrs = popRootKey(attrs)
      } else {
        const nestedAttrs = delete attrs.flash_options
        attrs = Object.assign({}, attrs, nestedAttrs)
      }
    }

    options || (options = {})

    attrs = rmCamelCaseAttrs(attrs)
    return super.set(attrs, options)
  }

  // Fetching flash_options doesn't return obj with root key
  parse (attrs) {
    // Patch up some  flash_options *values* that might be invalid from a Rails
    // model that allows nil for Flash, but shouldn't allow nil for viz. Proper
    // key structure for new/copy is still handled in
    // Poll.rb#merge_flash_options stuff
    if (attrs) {
      if (!_.isUndefined(attrs.headerLogoPlacement)) { if (!attrs.headerLogoPlacement) { attrs.headerLogoPlacement = 'center' } }
      attrs = rmCamelCaseAttrs(attrs)
    }

    return attrs
  }

  processLiveResponse (data = {}) {
    if (!this.throttledUpdate) {
      this.throttledUpdate = _.throttle((flashOptions) => {
        if (this.isSaving) { return }
        this.set(flashOptions)
      }, 1000)
    }

    if (data.flash_options && (this.poll && !this.poll.displayPanel)) {
      this.throttledUpdate(data.flash_options)
    }
  }
}
